module.exports = __webpack_public_path__ + "static/download.0353b060116ea2e38185b456588fd3c2.svg";